import { formatDate } from "../../utilities/CommonUtilities";

export class FetchDashboardDataRequest {
  constructor(dashboardName, filterDate, filterContries, filterCompanies,granularity) {
    this.dashboard_name = dashboardName;
    this.frame_work = "";
    let startDate =
      filterDate.startDate === "" ? new Date() : filterDate.startDate;
    startDate.setDate(startDate.getDate());
    this.start_date = formatDate(startDate);
    let endDate = filterDate.endDate === "" ? new Date() : filterDate.endDate;
    endDate.setDate(endDate.getDate());
    this.end_date = formatDate(endDate);
    if (filterCompanies) {
      this.company_id = filterCompanies;
    }
    if (filterContries) {
      this.countries = filterContries;
    }
    this.granularity = granularity
  }

  getRequest = () => {
    return JSON.stringify(this);
  };
}

export class FetchDashboardFiltersRequest {
  constructor(dashboardName, filterDate, filterContries, filterCompanies,granularity) {
    this.dashboard_name = dashboardName;
    let startDate =
      filterDate.startDate === "" ? new Date() : filterDate.startDate;
    startDate.setDate(startDate.getDate());
    this.start_date = formatDate(startDate);
    let endDate = filterDate.endDate === "" ? new Date() : filterDate.endDate;
    endDate.setDate(endDate.getDate());
    this.end_date = formatDate(endDate);
  }

  getRequest = () => {
    return JSON.stringify(this);
  };
}

export class FetchTopGainersAndLosersRequest {
  constructor(dashboardName, score_type) {
    this.dashboard_name = dashboardName;
    this.score_type = score_type
  }

  getRequest = () => {
    return JSON.stringify(this);
  };
}

export class DownloadDashboardDataRequest {
  constructor(dashboardName, filterDate, format, filterCountries, filterCompanies) {
    this.dashboard_name = dashboardName;
    this.frame_work = "";
    let startDate =
      filterDate.startDate === "" ? new Date() : filterDate.startDate;
    startDate.setDate(startDate.getDate());
    this.start_date = formatDate(startDate);
    let endDate = filterDate.endDate === "" ? new Date() : filterDate.endDate;
    endDate.setDate(endDate.getDate());
    this.end_date = formatDate(endDate);
    if (filterCompanies) {
      this.company_id = filterCompanies;
    }
    if (filterCountries) {
      this.countries = filterCountries;
    }
    this.file_format = format
  }

  getRequest = () => {
    return JSON.stringify(this);
  };
}



export class FetchPricesYFRequest {
  constructor(symbol, period, interval) {
    this.symbol = symbol;
    this.period = period;
    this.interval = interval;
  }
  getRequest = () => {
    return JSON.stringify(this);
  };
}